import Vue from 'vue';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import {setupDateSlider} from './_modules/date-slider.js';
import * as basicLightbox from 'basiclightbox'
import BuyTicketsComponent from './_components/BuyTicketsComponent.vue';
import MovieViewToggle from './_components/MovieViewToggle';
import cloneDeep from 'lodash/cloneDeep';
// // katie
// import axios from 'axios';
// const WhichBrowser = require('which-browser');

dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isSameOrBefore);

// a11yModal(document);

/*
(function() {
    let exLog = console.log;
    console.log = function(msg) {
        exLog.apply(this, arguments);
        axios.post('/api/logs', {data: btoa(JSON.stringify({
                console: 'log',
                arguments
            }))});
    }

    let exDebug = console.debug;
    console.debug = function(msg) {
        exDebug.apply(this, arguments);
        axios.post('/api/logs', {data: btoa(JSON.stringify({
                console: 'debug',
                arguments
            }))});
    }

    let exError = console.error;
    console.error = function(msg) {
        exError.apply(this, arguments);
        axios.post('/api/logs', {data: btoa(JSON.stringify({
                console: 'error',
                arguments
            }))});
    }
})()
*/

new Vue({
    el: "#homeBody",
    components: {
        MovieViewToggle,
        BuyTicketsComponent,
        // ToggleButton,
    },
    // mixins: [validationMixin],
    data: {
        // dates: dates,
        dateStart: dateStart,
        dateEnd: dateEnd,
        dateSelected: null,
        movies: movies,
        boxofficeOpen,
        // showings: showings,
        ticketTerms: ticketTerms,
        showingSelected: null,
        ajaxPending: false,
        view: null,
        viewByMovie: false,
        viewBy: 'day',
        salesStatuses: {
            // showingStarted: 0,
            // webNotAllowed: 1,
            // noSeatsAvailable: 2,
            // openFutureDay: 3,
            // openLaterToday: 4,
            // openNow: 5,
            // closed: 6,
            noSeatsAvailable: 1,
            webNotAllowed: 2,
            openFutureDay: 3,
            openLaterToday: 4,
            openNow: 5,
            boxofficeOnly: 6,
            closed: 8,
            
            
        }
    },

    computed: {
        dates: function() {
            let ret = [];
            let day = this.dateStart.clone();
            while (day <= this.dateEnd) {
                ret.push(day);
                day = day.add(1, 'day');
            }
            return ret;
        },
        moviesToShow: function() {
            if (this.viewByMovie || typeof singleMovie !== 'undefined') {
                return this.movies;
            }

            return this.moviesOnDate(this.dateSelected);
        },
        buyTicketsModalIsShown: function() {
            return this.showingSelected !== null;
        },
    },

    methods: {
        moviesOnDate: function(date) {
            let vue = this;

            date = dayjs.isDayjs(date) ? date : dayjs(date, 'YYYY-MM-DD');

            let movies = cloneDeep(vue.movies);
            for (let i = 0; i < movies.length; i++) {
                movies[i].showingDates = movies[i].showingDates.filter(function(showingDate) {
                    return date.isSame(showingDate.date, 'day');
                }).sort(function(a, b) {
                    if (a.date === b.date) {
                        return 0;
                    }
                    return (a.date > b.date) ? 1 : -1;
                });
                for (let j = 0; j < movies[i].showingDates.length; j++) {
                    movies[i].showingDates[j].showings.sort(function(a, b) {
                        if (a.shown_at === b.shown_at) {
                            return 0;
                        }
                        return (a.shown_at > b.shown_at) ? 1 : -1;
                    })
                }
            }
            return movies.filter(function(movie) {
                return movie.showingDates.length > 0;
            });
        },
        dateHasShowings: function(date) {
            return this.moviesOnDate(date).length > 0;
        },
        // noSeatsAvailable
        // webNotAllowed
        // openFutureDay
        // openLaterToday
        // openNow
        // boxofficeOnly
        // closed
        showingSalesStatus: function(showing) {
            console.debug(showing.shown_at.format(), showing.seating_pattern.screen_hashid, showing.seatsAvailable, showing.seatGroupsAvailable);
            // if (showing.seating_pattern.screen_hashid === '3ZR1M') { // outdoor; seating is a free-for-all zzz
            //     if (showing.seatsAvailable <= 0) {
            //         return this.salesStatuses.noSeatsAvailable;
            //     }
            // } else if (showing.seatGroupsAvailable <= 0) {
            // if (showing.seatGroupsAvailable <= 0) {
            //     return this.salesStatuses.noSeatsAvailable;
            // }
            if (showing.seatsAvailable <= 0) {
                return this.salesStatuses.noSeatsAvailable;
            }
            if (!showing.web_sales_allowed) {
                return this.salesStatuses.webNotAllowed;
            }
            if (showing.webSalesOpenAt.isAfter(dayjs().utc(), 'day')) {
                return this.salesStatuses.openFutureDay;
            }
            if (showing.shown_at.isSameOrBefore(dayjs.utc())) {
                return this.salesStatuses.closed;
            }
            if (showing.shown_at.isSame(dayjs.utc(), 'day')) {
                if (this.boxofficeOpen) {
                    return this.salesStatuses.boxofficeOnly;
                }
                if (showing.webSalesOpenAt.isAfter(dayjs.utc(), 'minute')) {
                    return this.salesStatuses.openLaterToday;
                }
            }
            return this.salesStatuses.openNow;
        },
        minutesToClose: function(showing) {
            return showing.webSalesCloseAt.diff(dayjs.utc(), 'minute');
        },
        minutesToOpen: function(showing) {
            return showing.webSalesOpenAt.diff(dayjs.utc(), 'minute');
        },
        todays: function(showings) {
            let vue = this;
            return (this.viewByMovie)
                ? showings
                : showings.filter(function(showing) {
                    return vue.dateSelected.isSame(dayjs.utc(showing.date).local(), 'day');
                })
            ;
        },
        showingDatesToShow: function(showingDates) {
            let vue = this;
            let dts = (this.viewByMovie)
                ? showingDates
                : [showingDates.find(function(showingDate) {
                    return vue.dateSelected.date() === showingDate.date.local().date();
                })]
            ;
            return dts;
        },
        showBuyTickets: function(movie, showing) {
            showing = cloneDeep(showing);
            showing.movie = cloneDeep(movie);
            delete showing.movie.showingDates;
            this.showingSelected = showing;

            document.querySelectorAll('html, body').forEach(function(elm) {
                elm.classList.add('noScrollUnderModal');
            });
            this.$nextTick(() => {
                this.$refs.buyTicketsForm.focusFirst();
/*
                // katie
                let params = new URLSearchParams(document.location.search);
                if (params.has('katie')) {
                    axios.post('/api/logs', {message: 'katie'});
                    // axios.post('/api/logs', {data: btoa(document.getElementsByTagName('html')[0].innerHTML)});
                    const bytes = (new TextEncoder().encode(document.getElementsByTagName('html')[0].innerHTML));
                    axios.post('/api/logs', {data: btoa(String.fromCodePoint(...bytes))});

                    const browser = new WhichBrowser(navigator.userAgent);
                    axios.post('/api/logs', {data: btoa(JSON.stringify(browser))});
                }
*/
            });
        },
        hideBuyTickets: function() {
            document.querySelectorAll('html, body').forEach(function(elm) {
                elm.classList.remove('noScrollUnderModal');
            });

            this.showingSelected = null;
        },
        // clickBuyTickets: function(evt) {
        //     if (evt.target.classList.contains('lightbox')) {
        //         evt.target.classList.remove('lightbox--visible');
        //     }
        // },
        showPosterLightbox: function(evt) {
            let src = evt.target.dataset.lightbox_src;
            (new Promise(function (resolve, reject) {
                let img = document.createElement('img');
                img.onload = function () {
                    resolve(src);
                };
                img.onerror = function () {
                    reject(src);
                };
                img.src = src;
            }))
                .then(function (src) {
                    let lb = basicLightbox.create('<img class="lightboxImage" src="' + src + '">');
                    lb.show();
                })
                .catch(function (err) {
                    console.error(err);
                })
            ;
        },
        showTrailer: function(slug, evt) {
            let movie = this.movies.find(elm => elm.slug === slug);
            evt.preventDefault();
            let iframe = `<div style="width: 90vw; height: 0; padding-bottom: 56%; margin: 0 auto;">
                <iframe style="position: absolute; width: 100%; height: 100%;" src="${movie.trailer}"
                    frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen
                ></iframe></div>`;
            basicLightbox.create(iframe).show();
        }
    },

    created: function() {
        let vue = this;
        // this.Views = {
        //     byDay: 1,
        //     byMovie: 2,
        // };
        // this.view = this.Views.byDay;

        // this.dates.forEach(function(date, idx, arr) {
        //     arr[idx] = dayjs(date).local();
        // });
        // this.dateSelected = this.dates[0];
        this.dateStart = dayjs(this.dateStart);
        this.dateEnd = dayjs(this.dateEnd);
        this.dateSelected = this.dateStart.clone();

        this.movies.forEach(function(movie, idxMovie, arrMovie) {
            // movie.showings.forEach(function(showing, idxShowing) {
            //     arrMovie[idxMovie].showings[idxShowing].shown_at = dayjs.utc(showing.shown_at, 'YYYY-MM-DD HH:mm:ss').local();
            // });
            movie.showingDates.forEach(function(showingDate, idxShowingDate) {
                arrMovie[idxMovie].showingDates[idxShowingDate].date = dayjs(showingDate.date, 'YYYY-MM-DD');
                showingDate.showings.forEach(function(showing, idxShowing) {
                    arrMovie[idxMovie].showingDates[idxShowingDate].showings[idxShowing].shown_at
                        = dayjs.utc(showing.shown_at, 'YYYY-MM-DD HH:mm:ss').local();
                    arrMovie[idxMovie].showingDates[idxShowingDate].showings[idxShowing].webSalesOpenAt
                        = dayjs.utc(showing.webSalesOpenAt, 'YYYY-MM-DD HH:mm:ss').local();
                    arrMovie[idxMovie].showingDates[idxShowingDate].showings[idxShowing].webSalesCloseAt
                        = dayjs.utc(showing.webSalesCloseAt, 'YYYY-MM-DD HH:mm:ss').local();
                    arrMovie[idxMovie].showingDates[idxShowingDate].showings[idxShowing].salesStatus
                        = vue.showingSalesStatus(showing);
                });
            });
        });
        // this.showings.forEach(function(showing, idxShowing) {
        //     showings[idxShowing].shown_at = dayjs.utc(showing.shown_at, 'YYYY-MM-DD HH:mm:ss').local();
        // });

        document.body.addEventListener('keydown', evt => {
            if (!vue.buyTicketsModalIsShown) {
                return;
            }
            if (evt.key === 'Tab') {
                if (evt.target.closest('#buyTickets') !== null) {
                    if (evt.shiftKey) {
                        vue.$refs.buyTicketsForm.moveFocusUp(evt);
                    } else {
                        vue.$refs.buyTicketsForm.moveFocusDown(evt);
                    }
                } else {
                    evt.preventDefault();
                    vue.$refs.buyTicketsForm.focusFirst();
                }
            }
        }, true);

    },
    mounted: function() {
        setupDateSlider();
        // console.debug(this.ticketTerms);
        // console.debug('new');
    }
});
